import React, {useEffect, useState} from 'react';
import moment from "moment";

function PurchaseDetail(props: any) {
    const {expense,...properties} = props;
    const [record,setRecord] = useState({
        id: 0,
        categoryName: "",
        subCategoryName: "",
        refNo: "",
        date: "",
        expenseFor: "",
        attachment: "",
        amount: "",
        note: "",
        isRecurring: "",
        recurringInterval: "",
        recurringPeriod: "",
        noOfRepetitions: "",
        repeatOn: "",
    });
    const [loaded,setLoaded] = useState(false);
    useEffect(() => {
        if (loaded==false){
            setRecord(expense);
            setLoaded(false);
        }
    })
    return (
        <>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card m-1">
                        <div className="card-header pb-0">
                            <div className="card-title-wrap bar-primary">
                                <div className="card-title">RECORD ID : {record.id}</div>
                                <hr/>
                            </div>
                        </div>
                        <div className="card-content">
                            <div className="card-body pt-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="bg-info pl-1 font-weight-bold white">Expense Info</p>
                                        <h5 className={"mb-1"}><strong>Expense Category :</strong> {record.categoryName}</h5>
                                        <h5 className={"mb-1"}><strong>Sub category :</strong> {record.subCategoryName}</h5>
                                        <h5 className={"mb-1"}><strong>Reference No :</strong> {record.refNo}</h5>
                                        <h5 className={"mb-1"}><strong>Date :</strong> {moment(record.date).format('YYYY-MM-DD')}</h5>
                                        <h5 className={"mb-1"}><strong>Expense For :</strong> {record.expenseFor}</h5>
                                        <h5 className={"mb-1"}><strong>Total Amount :</strong> {record.amount}</h5>
                                        <h5 className={"mb-1"}><strong>Note :</strong> {record.note}</h5>
                                    </div>
                                    <div className="col-md-12">
                                        { record.attachment?.endsWith(".pdf")?
                                            <embed src={record.attachment} type="application/pdf"  className={'w-100'} style={{minHeight:400}}></embed>
                                            :
                                            <img src={record.attachment} className={'w-100'}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PurchaseDetail;
